import { render, staticRenderFns } from "./NetworkConfig.vue?vue&type=template&id=2229039d&scoped=true&"
import script from "./NetworkConfig.vue?vue&type=script&lang=js&"
export * from "./NetworkConfig.vue?vue&type=script&lang=js&"
import style0 from "./NetworkConfig.vue?vue&type=style&index=0&id=2229039d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229039d",
  null
  
)

export default component.exports